<template>
    <div class="game">
        <section-game-header class="game__header" />

        <div class="game__section">
            <section-goods v-if="$route.name === 'game-goods'" />
            <section-good v-if="$route.name === 'game-good'" />
            <section-runtime v-if="$route.name === 'game-runtime'" />
            <section-result v-if="$route.name === 'game-result'" />

            <transition name="drop">
                <section-hello v-if="$route.name === 'hello'" />
            </transition>
        </div>

        <section-guide />

        <div class="control" v-if="idDev">
            <button v-if="minute !== 0 && (state === states.stop || state === states.pause)" @click="start">Start</button>
            <button v-if="state === states.run" @click="pause">Pause</button>
            <button v-if="state === states.pause || state === states.run" @click="stop">RESET</button>
            {{ time/1000 }}sec
        </div>

        <div class="log" v-if="false">
            <div>
                <table>
                    <tr>
                        <th align="left">Time</th>
                        <th align="left">Event</th>
                    </tr>
                    <tr v-for="(event, i) in history" :key="i" :class="event.theme">
                        <td>{{ (event.time/1000).toFixed(0) }}sec</td>
                        <td>{{ event.message }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'

    export default {
        data () {
            return {
                idDev: process.env.NODE_ENV !== 'production'
            }
        },
        computed: {
            ...mapState('control', ['startAt', 'pauseTime', 'states', 'state', 'time', 'minute']),
            ...mapState('history', ['history']),
            ...mapState(['game'])
        },
        methods: {
            ...mapActions('control', ['start', 'stop', 'pause'])
        },
        watch: {
            game (value) {
                if (value === 'win' || value === 'lose') {
                    this.$router.push({name: 'game-result'})
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .game {
        position relative
        display flex
        flex-direction column
        height 100%
        z-index 100

        &__header {}
        &__section {
            position relative
            flex 1 1
            & > div {
                height 100%
            }
        }
    }

    .control {
        position fixed
        top 0
        left 0
        z-index 10
        background-color #343434
    }

    .log {
        position fixed
        top 0
        right 0
        bottom 0
        transform translate(85%, 0)
        width 400px
        background-color #343434
        transition transform 0.3s ease
        z-index 100

        +layout-md() {
            display none
        }

        & > div {
            overflow auto
            height 100%
        }
        &:hover {
            transform translate(0, 0)
        }
        .success {
            background-color #1a6e00
        }
        .warn {
            background-color #630909
        }
    }


    .drop-leave-active {
        transition transform 0.6s ease
    }
    .drop-leave-to {
        transform translate(0, 100%)
    }
</style>
